export default __webpack_public_path__ + "static/media/user.79897f9c.svg";